/**
 * Dropdown options for Peaky Leads (Lead Finder) filters
 * EXACT values from: https://peaky-leads-scraper-app.netlify.app/
 */

export const SENIORITY_OPTIONS = [
  "Founder",
  "Chairman",
  "President",
  "CEO",
  "CXO",
  "Vice President",
  "Director",
  "Head",
  "Manager",
  "Senior",
  "Junior",
  "Entry Level",
  "Executive"
];

export const FUNCTIONAL_OPTIONS = [
  "Admin",
  "Analytics",
  "Applications",
  "Cloud",
  "Compliance",
  "Controller",
  "Customer Service",
  "Cyber Security",
  "Data Engineering",
  "Devops",
  "Digital",
  "Distribution",
  "Engineering",
  "Finance",
  "Fraud",
  "Hiring",
  "HR",
  "Infrastructure",
  "Inside Sales",
  "IT",
  "Learning",
  "Legal",
  "Marketing",
  "Network Security",
  "Operations",
  "Product Management",
  "Product Security",
  "Production",
  "Purchase",
  "Research",
  "Risk",
  "Sales",
  "Security",
  "Support",
  "Testing",
  "Training"
];

export const EMPLOYEE_SIZE_OPTIONS = [
  "0 - 1",
  "2 - 10",
  "11 - 50",
  "51 - 200",
  "201 - 500",
  "501 - 1000",
  "1001 - 5000",
  "5001 - 10000",
  "10000+"
];

export const REVENUE_OPTIONS = [
  "< 1M",
  "1M-10M",
  "11M-100M",
  "101M-500M",
  "501M-1B",
  "1B+"
];

export const BUSINESS_MODEL_OPTIONS = [
  "Product",
  "Services",
  "Solutions"
];

export const EMAIL_STATUS_OPTIONS = [
  { value: "verified", label: "Verified" },
  { value: "unverified", label: "Unverified" },
  { value: "unavailable", label: "Unavailable" }
];
